import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Tooltip} from "@interstate/components/Tooltip";
import {Badge} from "@interstate/components/Badge";
import {useInterstateToken} from "@interstate/components/InterstateThemeProvider";
import {BadgeBar} from "../../../../../badges";
import {useNavigation} from "../../../../../navigation";
import {EntitySourceType} from "../../../../EntitySourceType";
import {CreateResultNodeLabelProps} from "../common";
import {resultNodeBadgeMetadata} from "./resultNodeBadgeMetadata";
import "../common/CreateTreeNodeLabel.scss";

export const ResultsStepNodeLabel: FC<CreateResultNodeLabelProps> = ({
  node
}) => {
  const {t} = useTranslation();
  const {navigateToEntity} = useNavigation();
  const token = useInterstateToken();
  const {labelKey, variant, startIcon, endIcon} = resultNodeBadgeMetadata(
    token,
    node
  );

  const badge = (
    <Badge
      id={`create-result-node-badge-${node.caId}`}
      data-testid={`create-result-node-badge-${node.caId}`}
      className={"create-result-node-badge"}
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}>
      <span className={"create-result-node-badge-label"}>{t(labelKey!)}</span>
    </Badge>
  );

  return (
    <div
      id={`create-result-node-label-${node.caId}`}
      data-testid={`create-result-node-label-${node.caId}`}
      className={"create-tree-node-label create-result-node-label"}>
      <div className={"dba-name"}>
        <span>{node.dbaName}</span>
      </div>
      <BadgeBar>
        <div
          onClick={event => {
            if (node.status === "created") {
              event.stopPropagation();
              navigateToEntity(node.oeId!, EntitySourceType.OPERATIONAL);
            }
          }}>
          {node.message ? (
            <Tooltip
              position={"left"}
              size={"small"}
              toolTipContent={node.message}>
              {badge}
            </Tooltip>
          ) : (
            badge
          )}
        </div>
      </BadgeBar>
    </div>
  );
};
